import { RQ_VELOCITY_CONFIGURATION } from '@brighterion/utils/react-query-constants';
import { useQuery } from '@tanstack/react-query';
import { getVelocityConfigByRuleSetId } from 'Services';

const useGetVelocityConfigByRuleSetId = (ruleSetId: string) => {
    return useQuery([RQ_VELOCITY_CONFIGURATION, ruleSetId], () => getVelocityConfigByRuleSetId(ruleSetId));
};

export default useGetVelocityConfigByRuleSetId;
